import React, { useEffect, useState } from 'react';
import TextBox from 'devextreme-react/text-box';
import TextArea from 'devextreme-react/text-area';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { selectWorkshopTypes} from "../../../redux/workshopTypes/selectors";
import { SmsFormTypes } from '../../../Constantes/smsFormTypes';
import { QUERY_GET_ITVS_BY_POSTAL_CODE, QUERY_GET_PROVINCE_BY_POSTALCODE, QUERY_POST_SMS } from '../../../fetch/constantQueries';
import { openModal } from '../../../redux/modal/modalSlice';
import { baseRequest } from '../../../fetch/basicThunk';
import dayjs from 'dayjs';
import SendMailSmsForm from './SendMailSmsForm';
import DateBox from "../../common/CustomDateBox"
import SelectBox from "../../common/CustomSelectBox"
import { selectContract } from '../../../redux/contract/selectors';
import { selectCurrentCase } from '../../../redux/currentCase/selectors';
import { selectWorkshopSearchFilters, selectWorkshopSearchResults } from '../../../redux/workshopSearch/selectors';
import { FormActionButtons } from '../../common/FormActionButtons';
import { getCommentByCaseId, updateContractData } from '../../../redux/contract/thunks';
import { t } from 'i18next';

const useStyles = makeStyles({
    templateWrapper:{
        marginTop: "1rem",
        display: "flex",
        flexDirection: "column",
        rowGap: "1.5rem",
        maxHeight: "calc(100vh - 24rem)",
        overflowY: "auto"
    },
    phoneTemplateWrapper:{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "1rem"
    },
    hideSmsContainer: {
        display:"none"
    },
    input_grid: {
        display: "grid",
        columnGap: 10,
        gridTemplateColumns: "1fr 1fr"
    },
    workshopWrapper:{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        columnGap: "1rem",
    },
    localizatorWrapper:{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "1rem",
        rowGap: "1rem"
    }
  });

export default function SmsForm (props) {
    const classes = useStyles();
    const {templates, phoneNumber, cancelFunction, disableButtons, setAllButtonsToState, disabledButtom, setshowMessageForm, setDisabledButtom} = props;
    const workshopTypes = useSelector(selectWorkshopTypes);
    const dispatch = useDispatch()
    const [stations, setStations] = useState([])
    const contract = useSelector(selectContract);
    const currentCase = useSelector(selectCurrentCase)
    const workshopSearch = useSelector(selectWorkshopSearchResults)
    const [replacedSms, setReplacedSms] = useState()
    const workshopFilters = useSelector(selectWorkshopSearchFilters)
    const [dataSms,setDataSms] = useState({
            number:currentCase != null && currentCase.phoneNumber != null ? currentCase.phoneNumber : (contract.contractData == null || (!contract.contractData?.mobilePhone || contract.contractData?.mobilePhone.trim() === "")) ? contract.customerPhone == null ? "" : contract.customerPhone : contract.contractData.mobilePhone,
            contentSms: "",
            template: templates[0],
            plate: contract.plate != null ? contract.plate : "",
            workshopId:"",
            appointmentDate: null,
            workshopType: workshopFilters?.searchOption || "",
            email: contract.contractData?.email? contract.contractData.email : "",
            city:"",
            office:"",
            numberReference:"",
            sendMail: false
    })
    const [updatePauPhone, setUpdatePauPhone] = useState(dataSms.number !== currentCase.phoneNumber)

    function handleChangeSendSMSForm(field, value){
        setDataSms(prevState=>({...prevState, [field]:value}))
    }
    

    function handleTemplateChange (e) {
      let workshopType = "";
      if(workshopFilters?.searchOption){
        const {workshopTypeId} = workshopTypes.workshopTypes.find((w)=>w.workshopType === workshopFilters.searchOption);
        workshopType = workshopTypeId;
      }
    
        setDataSms(prevState => ({
          ...prevState,
          contentSms:e?.text,
          template:e,
          workshopType: workshopType ?? "",
          sendMail: false
        }));
        setReplacedSms(e.text)
    }

    useEffect(()=>{

         if(contract.contractData){
             setDataSms(prevState=>({...prevState,
               number: phoneNumber ? phoneNumber : contract.contractData?.mobilePhone?.trim() !== ""? contract.contractData?.mobilePhone : ""
             }))
         
         }
     },[contract.contractData, phoneNumber])

    useEffect(()=>{
     
        if(workshopFilters?.searchOption){
               const {workshopTypeId} = workshopTypes.workshopTypes.find((w)=>w.workshopType === workshopFilters.searchOption)
           setDataSms(prevState=>({
             ...prevState,
             workshopType: workshopTypeId
           }))
        }
     
     },
     [workshopFilters])


    // useEffect(()=>{
    //     if((dataSms.contentSms =="" || dataSms.contentSms ==null) || (initialTextSms =="" || initialTextSms ==null)){
    //         setInitialTextSms(dataSms.contentSms);
    //     }
    //     if(dataSms){
    //         setReplacedSms(replacedContentSms(dataSms.contentSms))
    //     }
    //   },[dataSms.contentSms])


    async function setProvince(){
        if(!dataSms?.postalCode || dataSms?.postalCode.length < 5 ){
            handleChangeSendSMSForm("province", null); 
            handleChangeSendSMSForm("stationId", null);
            return
        }
    
        const province = await fetchProvinceFromPostalCode(dataSms?.postalCode);
        
        if(province){
            const provinceHasNewValue = province.name !== dataSms?.province
            if(provinceHasNewValue){
                handleChangeSendSMSForm("stationId", null)
            }
            handleChangeSendSMSForm("province", province.name)
            fetchStations(dataSms?.postalCode)
        } else {
            handleChangeSendSMSForm("stationId", null)
        }
    }

    async function fetchProvinceFromPostalCode(postalCode){
        let province;
        try {
            province = await baseRequest({param: postalCode }, dispatch, QUERY_GET_PROVINCE_BY_POSTALCODE, "GET");
        } catch (error) {
            province = null
            handleChangeSendSMSForm("province", null)
            setStations([])
        }    
        return province
    }

    async function fetchStations(postalCode){

        try {
            const stations = await baseRequest({param: postalCode }, dispatch, QUERY_GET_ITVS_BY_POSTAL_CODE, "GET")
            if(stations){
                setStations(stations)
            }
        } catch (error) {
            dispatch(openModal({type: "error", message: "No se han podido cargar las ITVs"}))
        }
    }

    function replacedContentSms(originalContent,field = "", newValue = null){
        let content = originalContent;
        if(dataSms.template){
            if((dataSms.template?.templateCode == "itv_bond" ||  dataSms.template?.templateCode == "telematic_copy" || dataSms.template?.templateCode == "standard_send") && ((!newValue && dataSms?.email != null && dataSms?.email !="") || newValue)){
                content = content.replace('%email%', newValue? newValue : dataSms?.email);
            }
            if(dataSms.template.templateCode =="itv_appointment" ){
                if((!newValue && dataSms?.appointmentDate != null && dataSms?.appointmentDate !="") || (newValue && newValue instanceof Date)){
                    content = content.replace('%date%', newValue ? dayjs(newValue).format("DD/MM/YYYY HH:mm") : dayjs(dataSms?.appointmentDate).format("DD/MM/YYYY HH:mm"));
                }else if(newValue && !(newValue instanceof Date) && (dataSms?.appointmentDate != null && dataSms?.appointmentDate !="")){
                    content = content.replace('%date%', dayjs(dataSms?.appointmentDate).format("DD/MM/YYYY HH:mm"));
                }
                if((!newValue && dataSms?.stationId != null && dataSms?.stationId !="") || newValue){
                    var id = field=="station"? newValue : dataSms?.stationId
                    let station =stations.find((s)=>s.id == id);
                    if(station){
                        content = content.replace('%station%',station.city + ","+ station.address);
                    }
                }
            } else if(dataSms.template.templateCode =="substitution_reference_number" ){
                if((!newValue && dataSms?.date != null && dataSms?.date !="") || (newValue && newValue instanceof Date)){
                    content = content.replace('%date%', newValue ? dayjs(newValue).format("DD/MM/YYYY HH:mm") : dayjs(dataSms?.date).format("DD/MM/YYYY HH:mm"));
                }else if(newValue && !(newValue instanceof Date) && (dataSms?.date != null && dataSms?.date !="")){
                    content = content.replace('%date%', dayjs(dataSms?.date).format("DD/MM/YYYY HH:mm"));
                }
                if(((!newValue && dataSms?.city != null && dataSms?.city !="") || newValue)){
                    content = content.replace('%city%', field=="city"? newValue ? newValue : '%city%' : dataSms?.city ? dataSms?.city : '%city%');
                }
                if(((!newValue && dataSms?.office != null && dataSms?.office !="") || newValue)){
                    content = content.replace('%office%', field=="office"?  newValue ? newValue : '%office%' : dataSms?.office ? dataSms?.office : '%office%');
                }
                if(((!newValue && dataSms?.numberReference != null && dataSms?.numberReference !="") || newValue)){
                    content = content.replace('%number%',  field=="numberReference"?  newValue ? newValue : '%number%' : dataSms?.numberReference? dataSms?.numberReference : '%number%');
                }
            }
        }
        return content;
    }

    function resetValue(previousValue, field){
        if(field === "station"){
                        let station =stations.find((s)=>s.id == previousValue);
                if(station){
                    let prevValue = station.city + ","+ station.address
                        setReplacedSms(replacedSms.replace(prevValue,'%station%'));  
                }
        } else if(field === "date"){
                setReplacedSms(replacedSms.replace(dayjs(previousValue).format("DD/MM/YYYY HH:mm"), `%date%`)); 
        } else {
                setReplacedSms(replacedSms.replace(previousValue, `%${field}%`));  
        }

    }

    function replaceAlreadyChangedContentSms(previousValue, newValue, field = null){

        if(previousValue && newValue === null){
                resetValue(previousValue, field)
        } else if(newValue == null || newValue == ""){
            setReplacedSms(replacedContentSms(replacedSms, field, newValue))
        }
        else if(previousValue == null || previousValue == ""){
            setReplacedSms(replacedContentSms(replacedSms, field, newValue))
        }
        else{
            if(field=="date"){
                setReplacedSms(replacedSms.replace(dayjs(previousValue).format("DD/MM/YYYY HH:mm"),dayjs(newValue).format("DD/MM/YYYY HH:mm"), field));  
            }else if(field == "station"){
                let station =stations.find((s)=>s.id == previousValue);
                if(station){
                    let prevValue = station.city + ","+ station.address
                    let newStation =stations.find((s)=>s.id == newValue);
                    if(newStation){
                        setReplacedSms(replacedSms.replace(prevValue,newStation.city + ","+ newStation.address), field);  
                    }
                }
            }else{
                setReplacedSms(replacedContentSms(replacedSms, field, newValue))
            }
        }   
    }

    //Evento de envio de SMS
    async function handleSendSmsForm () {
        if(!dataSms.template.templateId){
          dispatch(openModal({ type: "warning", message:"Es obligatorio seleccionar una plantilla."}))
        };
        if (dataSms.number == null || dataSms.number == "" ) {
          dispatch(openModal({ type: "warning", message:"El número de telefóno es obligatorio."}));
        } else if ((dataSms.contentSms == null || dataSms.contentSms == "") && (dataSms.template != null && dataSms.template.type != "Certificado")) {
          dispatch(openModal({ type: "warning", message:"El mensaje del SMS no puede estar vacío."}));
        }
        else if ( dataSms.template != undefined &&  dataSms.template.type == "Certificado" && (dataSms.workshopId == null || dataSms.workshopId == "")) {
          dispatch(openModal({ type: "warning", message:"El taller no puede estar vacío."}));
        }
        else if ( dataSms.template != undefined &&  dataSms.template.type == "Certificado" && (dataSms.workshopType == null || dataSms.workshopType == "")) {
          dispatch(openModal({ type: "warning", message:"El tipo de taller no puede estar vacío."}));
        }
        else if ( dataSms.template != undefined &&  dataSms.template.type == "Certificado" && (dataSms.appointmentDate == null || dataSms.appointmentDate == "") && dataSms.template.name == "Cita Taller") {
          dispatch(openModal({ type: "warning", message:"La fecha de la cita no puede estar vacía."}));
        }
        else if ( dataSms.template != undefined &&  dataSms.template.type == "Certificado" && (dataSms.plate == null || dataSms.plate == "")) {
          dispatch(openModal({ type: "warning", message:"La matrícula no puede estar vacía."}));
        }
        else {
          const prevButtonsState = {...disabledButtom};
          setAllButtonsToState({disabled: true});
            const submitData = {
              numbers: [dataSms.number],
              text: replacedSms ? replacedSms : dataSms.contentSms,
              workshopId: dataSms.workshopId,
              workshopType: dataSms.workshopType?.toString(),
              plate: dataSms.plate? dataSms.plate : currentCase.plate === null ? "" : currentCase.plate,
              smsType: dataSms.template == undefined || dataSms.template.type == null ? "Normal" : dataSms.template.type,
              caseId: currentCase.caseId.toString(),
              templateId: dataSms.template.templateId,
              appointmentDate: dataSms.appointmentDate != null ? dayjs(dataSms.appointmentDate).format("DD/MM/YYYY HH:mm") : "",
              email: dataSms.email,
              stationId: dataSms.stationId,
              date: dataSms.date,
              sendAssociatedEmail: dataSms.sendMail
            };
            try {
              await baseRequest({body: submitData}, dispatch, QUERY_POST_SMS, "POST")
              const successMessage = submitData.sendAssociatedEmail ? "SMS + Email enviado" : "SMS enviado";
              dispatch(openModal({ type: "success", message: successMessage}));
              dispatch(getCommentByCaseId({query: `?caseId=${currentCase.caseId}`}));

              updatePauData(dataSms);
              setDataSms(prevState => ({
                  number: currentCase != null && currentCase.phoneNumber != null ? currentCase.phoneNumber : contract.contractData == null ? contract.customerPhone == null ? "" : contract.customerPhone : contract.contractData.mobilePhone,
                  plate: contract.plate != null ? contract.plate : "",
                  contentSms:"",
                  smsType:"",
                  appointmentDate:null,
                  workshopType: null,
                  sendMail: false
                }))
                const shouldUpdatePauPhoneWhenSaving = currentCase != null && currentCase.phoneNumber != null;
                setUpdatePauPhone(shouldUpdatePauPhoneWhenSaving) 
                setshowMessageForm(false);
    
                
            } catch (error) {
            }
            finally{  
                setDisabledButtom(prevButtonsState);
            }
        }
    }

    async function updatePauData(dataDoct){
      const contractHasPauData = contract.contractData? true: false;
      const hasNewMobilePhone = contractHasPauData && dataDoct.number && dataDoct.number.trim() !== contract.contractData?.mobilePhone;
       if((!contractHasPauData || hasNewMobilePhone) && updatePauPhone){
    
         const submitData = {
          contractDataId: contract.contractData?.contractDataId,
          userName: contract.contractData?.userName,
          userSurnames: contract.contractData?.userSurnames,
          mobilePhone: hasNewMobilePhone || !contractHasPauData? dataDoct.number : contract.contractData?.mobilePhone,
          phone:contract.contractData?.phone,
          email: contract.contractData?.email,
          driversClub: contract.contractData?.driversClub,
          driversClubDate: contract.contractData?.driversClubDate? dayjs(contract.contractData?.driversClubDate,"DD/MM/YYYY").format("YYYY/MM/DD") : null,
          kilometrage: contract.contractData?.kilometrage,
          licenseNumber: contract.contractData?.licenseNumber
         }
    
         await dispatch(updateContractData({param: contract.id, body: submitData}))
        }
      }

    return (
    <>
    <div className={classes.templateWrapper}>   
                <div className={classes.phoneTemplateWrapper}>
                    <SelectBox label='Plantilla' labelMode='floating' value={dataSms.template} displayExpr="name" onValueChanged={(e)=>{e.previousValue?.templateId !== e.value?.templateId  && handleTemplateChange(e.value)}} dataSource={templates}  ></SelectBox>
                    <TextBox label='Teléfono' labelMode='floating' maxLength={25} valueChangeEvent="keyup" onValueChanged={(e)=>handleChangeSendSMSForm("number",e.value)} value={dataSms.number} className={classes.controlers} ></TextBox>
                </div>
                {
                    ( dataSms.template!=null && dataSms.template.type == "Certificado")  &&
                    <>
                                <div className={classes.workshopWrapper}>
                                    { workshopSearch == undefined || workshopSearch.length == 0?
                                    <TextBox label='Taller' labelMode='floating' value={dataSms.workshopId} onValueChange={(e)=>handleChangeSendSMSForm("workshopId",e)} placeholder="Id del taller" maxLength={25} valueChangeEvent="keyup" className={classes.controlers} ></TextBox>
                                    :<SelectBox label='Taller' labelMode='floating' value={dataSms.workshopId} valueExpr="workshopId" displayExpr="name" onValueChange={(e)=>handleChangeSendSMSForm("workshopId",e)} placeholder="" dataSource={workshopSearch} ></SelectBox> }
                                    <SelectBox label={t("Type")} labelMode='floating' disabled={workshopSearch != undefined || workshopSearch?.length > 0} value={dataSms.workshopType} valueExpr="workshopTypeId" displayExpr="workshopType" onValueChange={(e)=>handleChangeSendSMSForm("workshopType",e)} placeholder="Tipo taller" dataSource={workshopTypes?.workshopTypes} ></SelectBox>
                                    <TextBox label='Matrícula' labelMode='floating' value={dataSms.plate} maxLength={25} onValueChange={(e)=>handleChangeSendSMSForm("plate",e)} valueChangeEvent="keyup"  className={classes.controlers} ></TextBox>
                                </div>             
                    {
                            (dataSms.template!=null && dataSms.template.name == "Cita Taller") &&
                            <>
                                        <DateBox
                                        type="datetime"
                                        label='Fecha de cita'
                                        labelMode='floating'
                                        className={classes.controlers} 
                                        value={dataSms.appointmentDate}
                                        min={new Date().toISOString().slice(0, 10)}
                                        showClearButton={true}
                                        useMaskBehavior={true}
                                        acceptCustomValue={false}
                                        displayFormat="dd/MM/yyyy HH:mm"
                                        applyButtonText="Aceptar"
                                        cancelButtonText="Cancelar"
                                        onValueChanged={(e)=>handleChangeSendSMSForm("appointmentDate",e.value)} />
                                <SendMailSmsForm classes={classes} onValueChange={handleChangeSendSMSForm} dataSms={dataSms} />
                            </>
                        }
                    </>
                }
                {( dataSms.template != null && dataSms.template.templateCode =="itv_appointment")  &&
                    <>
                        <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", rowGap: "1rem", columnGap: "1rem"}}>
                                <TextBox label='Código postal' labelMode='floating' maxLength={5} key={"postalCode"} name="postalCode" value={dataSms?.postalCode} onFocusOut={()=>setProvince()}  onValueChanged={(e) => handleChangeSendSMSForm("postalCode", e.value)} className={classes.controlers} ></TextBox>
                                <TextBox label='Provincia' labelMode='floating' disabled key={"province"} name="province" value={dataSms?.province} className={classes.controlers} ></TextBox>

                            <SelectBox 
                                label='Estación' 
                                labelMode='floating' 
                                value={dataSms?.stationId} 
                                valueExpr={"id"} 
                                placeholder={""}
                                disabled={!dataSms?.province}
                                searchEnabled
                                onValueChanged={(e) =>{ 
                                        replaceAlreadyChangedContentSms(dataSms?.stationId, e.value,"station");
                                        handleChangeSendSMSForm("stationId",e.value); 
                                }} 
                                itemRender={(item)=><div style={{whiteSpace: "normal"}}> <span style={{fontWeight: "bold"}}>{item && `${item.city}`}</span>{item? `, ${item?.address ? item.address : ""} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""}</div>}
                                displayExpr={(item)=> item? `${item?.city}, ${item?.address} | ${item?.concerted? "Concertado" : "No concertado"} | ${item.net}`: ""} 
                                dataSource={stations}
                                noDataText={"No hay opciones disponibles"}>
                            </SelectBox>
                            <DateBox label='Fecha y hora' labelMode='floating' applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" displayFormat="dd/MM/yyyy HH:mm" value={dataSms?.appointmentDate} onValueChanged={(e) =>{ handleChangeSendSMSForm("appointmentDate", e.value);replaceAlreadyChangedContentSms(dataSms?.appointmentDate, e.value,"date");}} ></DateBox>
                        </div>
                        <SendMailSmsForm classes={classes} onValueChange={handleChangeSendSMSForm} dataSms={dataSms} />
                    </>
                    }
                    {( dataSms.template != null && dataSms.template.templateCode =="substitution_reference_number")  &&
                        <div className={classes.localizatorWrapper}>
                            <DateBox label='Fecha y hora' labelMode='floating' applyButtonText="Aceptar" cancelButtonText="Cancelar" key={"date"} name="date" type="datetime" displayFormat="dd/MM/yyyy HH:mm" value={dataSms?.date} onValueChanged={(e) =>{ handleChangeSendSMSForm("date",e.value);replaceAlreadyChangedContentSms(dataSms?.date, e.value,"date");}}></DateBox>
                            <TextBox labelMode='floating' label="Localidad" key={"city"} name="city" value={dataSms?.city} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.city, e.target.value,"city"); handleChangeSendSMSForm("city",e.target.value); }} ></TextBox>
                            <TextBox labelMode='floating' label="Oficina" key={"office"} name="office" value={dataSms?.office} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.office, e.target.value,"office"); handleChangeSendSMSForm("office",e.target.value); }}></TextBox>
                            <TextBox labelMode='floating' label="Nº de Localizador" key={"numberReference"} name="numberReference" value={dataSms?.numberReference} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.numberReference, e.target.value,"numberReference"); handleChangeSendSMSForm("numberReference",e.target.value); }}></TextBox> 
                        </div>
                    }
                    {( dataSms.template != null && (dataSms.template?.templateCode == "itv_bond" ||  dataSms.template?.templateCode == "telematic_copy" || dataSms.template?.templateCode == "standard_send"))  &&
                        <div>
                                <TextBox label='Correo electrónico' labelMode='floating' key={"email"} name="email" value={dataSms?.email} autocomplete="off" onChange={(e) =>{replaceAlreadyChangedContentSms(dataSms?.email, e.target.value); handleChangeSendSMSForm("email",e.value); }}></TextBox>  
                        </div>
                    }
                {((dataSms.template == null || dataSms.template.type != "Certificado"))  &&
                        <div>
                                <TextArea label='Mensaje' labelMode='floating' maxLength={250} valueChangeEvent="keyup" 
                                    onValueChanged={(e)=>{handleChangeSendSMSForm("contentSms",e.value)}} 
                                    value={replacedSms} width={"100%"} height={150}></TextArea>
                        </div>
                }
                <div>
                </div>
            </div>
            <div style={{paddingTop: "1rem", paddingBottom: "1rem"}}>
                <FormActionButtons
                    cancelFunction={cancelFunction}
                    submitFunction={handleSendSmsForm}
                    submitText={t("Send")}
                    cancelText={t("Cancel")}
                    disabled={disableButtons}
                />
            </div>
        </>    
        );
}